export enum BookkeepingItemType {
  Invoice = 'invoice',
  Bill = 'bill',
  ExternalInvoice = 'externalInvoice',
  Posting = 'posting',
}
